import { combineReducers } from 'redux';
import user from './user';
import tests from './tests';

export default combineReducers({
  user,
  tests,
});
